import { useCallback, useState } from "react";

import {
    ArrowButton, ExpandablePanel, ExpandablePanelBody, ExpandablePanelHeader, Select, Button, Typography, Table, useTable, TableMetadata, Label,
    Checkbox, Modal, TextField, Autocomplete, DatePicker, AutocompleteSearchData, SelectData
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as DownloadIcon } from "@king-ict/eupisi-ui/components/Icon/Download.svg";
import { CodeBook, ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData, nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { getGroupProgramRequests, createGroupProgramRequest, searchProgramNamesV2, exportGroupProgramRequests, DocumentUploadRequest, uploadDocument } from "../../api/nisooApi";
import { OtherLegalEntityLocationModal } from "../../components/FormControls/OtherLegalEntityLocationModal";
import { DocumentType } from "../../models/Document";
import { GroupProgramRequest, ProgramRequestSearch, GroupProgramRequestsListItem, CreateGroupProgramRequestRequest } from "../../models/GroupProgramRequest";
import { ProgramRequestType, OtherLegalEntityLocation, createOtherLegalEntityLocation } from "../../models/ProgramRequest";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetGroupProgramRequestTypesQuery, useGetEducationSectorsQuery, useGetProgramTypesQuery, useGetProgramNamesCodeQuery } from "../../queries/codeBookQuery";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { dashboardRoute, programRequestListRoute } from "../../routes/routes";
import { getProgramRequestStatusColor } from "../../utils/programRequestUtils";
import styles from "./CreateGroupProgramRequest.module.scss";




export function CreateGroupProgramRequest() {
    const history = useHistory();
    const { t } = useTranslation();

    const [tableData, setTableData] = useState<GroupProgramRequestsListItem[]>([]);

    const groupProgramRequestsListItemTableMetadata: TableMetadata<GroupProgramRequestsListItem> = {
        rowKey: "programRequestId",
        columns: [
            {
                columnKey: "isSelected",
                header: "",
                accessor: (item: GroupProgramRequestsListItem) => {
                    return (
                        <div>
                            <Checkbox
                                label={""}
                                name={nameof<typeof item>("programRequestId")}
                                value={item.programRequestId}
                                checked={item.isSelected}
                                onChange={handleItemCheckedChanged}
                            />
                        </div>
                    );
                }
            },
            {
                columnKey: "programName",
                header: t("common.programName"),
                accessor: "programName"
            },
            {
                columnKey: "programTypeName",
                header: t("common.programType"),
                accessor: "programTypeName"
            },
            {
                columnKey: "sectorName",
                header: t("common.educationSector"),
                accessor: "educationSectorName"
            },
            {
                columnKey: "programRequestStatusName",
                header: t("common.status"),
                accessor: (item: GroupProgramRequestsListItem) => {
                    return (
                        <div className={"d-flex align-center"}>
                            <Label color={getProgramRequestStatusColor(item.programRequestStatusId)}>
                                {item.programRequestStatusName}
                            </Label>
                        </div>
                    );
                }
            }
        ],
        rowToolTip: () => undefined
    };

    const [tableProps] = useTable<GroupProgramRequestsListItem>(
        {
            metadata: groupProgramRequestsListItemTableMetadata,
            data: tableData,
            pagination: false,
            paginationPage: undefined,
            paginationPageSize: undefined,
            totalItems: 1,
            defaultSort: {}
        }
    );

    const createDefaultGroupProgramRequest = (): GroupProgramRequest => {
        return {
            type: { id: 1, name: "" }
        };
    };

    const createDefaultGroupProgramRequestSearch = (): ProgramRequestSearch => {
        return {
            educationSector: undefined,
            // program: undefined,
            programId: undefined,
            programType: undefined
        };
    };

    const createDefaultCreateGroupProgramRequestRequest = (): CreateGroupProgramRequestRequest => {
        return {
            institutionId: 0,
            groupProgramRequestTypeId: 0,
            groupProgramRequestDate: new Date(),
            lastStatusId: 1,
            registrationDate: new Date(),
            receivedById: 0,
            programRequestIds: [],
            otherLegalEntityLocations: []
        };
    };


    const [createGroupProgramRequestRequest, setCreateGroupProgramRequestRequest] = useState<CreateGroupProgramRequestRequest>(createDefaultCreateGroupProgramRequestRequest);
    const [groupProgramRequest, setGroupProgramRequest] = useState<GroupProgramRequest>(createDefaultGroupProgramRequest);
    const [programRequestSearch, setProgramRequestSearch] = useState<ProgramRequestSearch>(createDefaultGroupProgramRequestSearch);
    const [isOtherLegalEntityModalOpened, setIsOtherLegalEntityModalOpened] = useState(false);
    const [isConfirmModalOpened, setIsConfirmModalOpened] = useState(false);
    const [isInformationModalOpened, setIsInformationModalOpened] = useState(false);
    const [createdGroupProgramRequestID, setCreatedGroupProgramRequestID] = useState(0);
    const [isSelectedProgramValidationModalOpened, setIsSelectedProgramValidationModalOpened] = useState(false);
    const [otherLegalEntityLocationModalOpened, setOtherLegalEntityLocationModalOpened] = useState(false);
    const [otherLegalEntityLocation, setOtherLegalEntityLocation] = useState<OtherLegalEntityLocation | undefined>();

    const { data: userSession } = useGetUserSessionQuery();
    const { data: groupProgramRequestTypes } = useGetGroupProgramRequestTypesQuery();
    const { data: educationSectors } = useGetEducationSectorsQuery();
    const { data: programs } = useGetProgramNamesCodeQuery();
    const { data: programTypes } = useGetProgramTypesQuery();


    const onBackToRequestList = () => {
        if (userSession) {
            if (userSession.roleId === RoleEnum.InstitutionAdmin || userSession.roleId === RoleEnum.InstitutionDirector) {
                history.push(dashboardRoute());
            }
            else {
                history.push(programRequestListRoute());
            }
        }
    };

    const handleToggleCancelOtherLegalEntityModal = () => {
        setIsOtherLegalEntityModalOpened((prev) => !prev);
    };

    const handleToggleCancelConfirmModal = () => {

        var selectedCount = tableData.filter(x => x.isSelected === true).length;

        if (groupProgramRequest.type.id === ProgramRequestType.InstitutionBasicDataChange && (selectedCount == 0 || selectedCount > 30)) {
            handleToggleCloseValidationModal();
            return;
        }

        if (groupProgramRequest.type.id !== ProgramRequestType.InstitutionBasicDataChange && (selectedCount === 0 || selectedCount > 10)) {
            handleToggleCloseValidationModal();
            return;
        }

        setIsConfirmModalOpened((prev) => !prev);

        var selectedProgramRequests = tableData.filter(x => x.isSelected === true).map((t) => t.programRequestId);
        var institutionID = tableData.find(x => x.isSelected === true)?.institutionId;

        const newCreateGroupProgramRequestRequest: CreateGroupProgramRequestRequest = {
            ...createGroupProgramRequestRequest,
            groupProgramRequestTypeId: groupProgramRequest.type.id,
            programRequestIds: selectedProgramRequests,
            registrationDate: new Date(),
            groupProgramRequestDate: new Date(),
            institutionId: institutionID ? institutionID : 0
        };

        setCreateGroupProgramRequestRequest(newCreateGroupProgramRequestRequest);
    };

    const handleToggleConfirmOtherLegalEntityModal = () => {
        setIsConfirmModalOpened(true);
    };

    const handleToggleCancelInformationModal = () => {
        setIsInformationModalOpened((prev) => !prev);
        window.location.href = '/radna-ploha';
    };

    const handleToggleCloseValidationModal = () => {
        setIsSelectedProgramValidationModalOpened((prev) => !prev);
    }

    const handleToggleConfirmConfirmModal = () => {
        if (groupProgramRequest.type.id === ProgramRequestType.ConsentForExecutionAtTheLocationOfAnotherLegalEntityMZO) {
            setOtherLegalEntityLocation(createOtherLegalEntityLocation);
            setOtherLegalEntityLocationModalOpened(true);
        }
        else {
            createGroupProgramRequest(createGroupProgramRequestRequest).then((value: number) => {
                setCreatedGroupProgramRequestID(value);
                handleToggleCancelInformationModal();
                setIsConfirmModalOpened(false);
            });
        }
    };

    const handleConfirmedOtherLegalEntityLocationModal = async (item: OtherLegalEntityLocation) => {
        await uploadOtherLegalEntityLocationDocuments(item);

        for (let i = 0; i < createGroupProgramRequestRequest.programRequestIds.length; i++) {

            createGroupProgramRequestRequest.otherLegalEntityLocations.push(item);
        }

        await createGroupProgramRequest(createGroupProgramRequestRequest).then((value: number) => {
            setOtherLegalEntityLocationModalOpened(false);
            setCreatedGroupProgramRequestID(value);
            handleToggleCancelInformationModal();
            setIsConfirmModalOpened(false);
        });
    };

    const uploadOtherLegalEntityLocationDocuments = async (item: OtherLegalEntityLocation) => {
        if (item.programExecutionRequestDocument && item.programExecutionRequestDocument.id === -1) {
            var programExecutionRequestDocumentRequest: DocumentUploadRequest = {
                document: item.programExecutionRequestDocument!.file!,
                documentTypeId: DocumentType.OtherLegalEntityProgramExecutionRequest                
            };
            await uploadDocument(programExecutionRequestDocumentRequest).then((idDoc) => {
                item.programExecutionRequestDocument!.id = idDoc;
            });
        }
        if (item.ministryConsentDocument && item.ministryConsentDocument.id === -1) {
            var ministryConsentDocumentRequest: DocumentUploadRequest = {
                document: item.ministryConsentDocument!.file!,
                documentTypeId: DocumentType.OtherLegalEntityMinistryConsent              
            };
            await uploadDocument(ministryConsentDocumentRequest).then((idDoc) => {
                item.ministryConsentDocument!.id = idDoc;
            });
        }
    }

    const handleCancelOtherLegalEntityLocationModal = () => {
        setOtherLegalEntityLocationModalOpened(false);
        setOtherLegalEntityLocation(undefined);
    };


    const handleItemCheckedChanged = (e: any) => {
        const id = Number.parseInt(e.target.value);
        const isChecked = e.target.checked as boolean;

        if (id) {

            const newTableData = tableData.map(x => {
                if (x.programRequestId === id) {
                    return { ...x, isSelected: isChecked };
                }
                return x;
            });
            setTableData(newTableData);
        }
    };

    const handleGroupProgramRequestTypeChange = (e: any) => {
        const groupProgramRequestTypeId = Number.parseInt(e.target.value);
        var groupProgramRequestType: CodeBook = { id: groupProgramRequestTypeId, name: "" };
        const newGroupProgramRequest: GroupProgramRequest = {
            ...groupProgramRequest,
            type: groupProgramRequestType
        };
        setGroupProgramRequest(newGroupProgramRequest);
        if (tableData && tableData.length > 0) {
            clearFilters();
        }
    };

    const handleProgramRequestEducationSectorChange = (e: any) => {
        const programRequestEducationSectorId = Number.parseInt(e.target.value);
        var programRequestEducationSector: CodeBook = { id: programRequestEducationSectorId, name: "" };
        const newProgramRequestSearch: ProgramRequestSearch = {
            ...programRequestSearch,
            educationSector: programRequestEducationSector
        };
        setProgramRequestSearch(newProgramRequestSearch);
    };

    // const handleProgramRequestProgramChange = (e: any) => {
    //     const programRequestProgramId = Number.parseInt(e.target.value);
    //     var programRequestProgram: CodeBook = {id: programRequestProgramId, name: ""};
    //     const newProgramRequestSearch: ProgramRequestSearch = {
    //         ...programRequestSearch,
    //         program: programRequestProgram
    //     };
    //     setProgramRequestSearch(newProgramRequestSearch);
    // };

    const handleProgramIdChange = (e: any) => {
        let programId = undefined;
        if (e.target.value) {
            programId = Number.parseInt(e.target.value);
        }
        const newProgramRequestSearch: ProgramRequestSearch = {
            ...programRequestSearch,
            programId: programId
        };
        setProgramRequestSearch(newProgramRequestSearch);
    };

    const handleProgramNameSearch = useCallback(
        async (search: AutocompleteSearchData) => {
            if (search.text) {
                const programNames = await searchProgramNamesV2(search.text);
                return {
                    valueProp: "id",
                    textProp: "name",
                    data: programNames
                } as SelectData<CodeBook>
            }
            return {
                valueProp: "id",
                textProp: "name"
            } as SelectData<CodeBook>
        }, []
    );

    const handleProgramRequestProgramTypeChange = (e: any) => {
        const programRequestProgramTypeId = Number.parseInt(e.target.value);
        var programRequestProgramType: CodeBook = { id: programRequestProgramTypeId, name: "" };
        const newProgramRequestSearch: ProgramRequestSearch = {
            ...programRequestSearch,
            programType: programRequestProgramType
        };
        setProgramRequestSearch(newProgramRequestSearch);
    };

    const clearFilters = () => {
        var emptySearch = {
            educationSector: undefined,
            program: undefined,
            programType: undefined
        };
        setProgramRequestSearch(emptySearch);
        setTableData([]);
    };

    const search = async () => {
        var request = {
            educationSectorId: programRequestSearch.educationSector?.id,
            programId: programRequestSearch?.programId,
            programTypeId: programRequestSearch?.programType?.id,
            requestTypeId: groupProgramRequest?.type?.id
        };

        var result = await getGroupProgramRequests(request);
        setTableData(result);

    };

    const download = async (exportType: ExportTypeEnum) => {
        const request = {
            educationSectorId: programRequestSearch.educationSector?.id,
            programId: programRequestSearch?.programId,
            programTypeId: programRequestSearch?.programType?.id,
            requestTypeId: groupProgramRequest?.type?.id,
            exportType: exportType
        }

        await exportGroupProgramRequests(request);
    }

    return (
        <>
            <Row>
                <Col md={3}>
                    <ArrowButton
                        backwards
                        ariaLabel={t("common.returnToRequestList")}
                        onClick={onBackToRequestList}
                    />
                    <span className={styles.backButtonCaption}>
                        {t("common.returnToRequestList")}
                    </span>
                </Col>
                <Col md={9}>
                    <b>{t("request.newGroupRequestTitle")}</b>
                </Col>
            </Row>
            <Row>
                <Col md={12} className={styles.panelsCol}>
                    <ExpandablePanel expanded clickableHeader className={styles.panel}>
                        <ExpandablePanelHeader className={styles.panelHeader}>
                            {t("request.groupProgramRequestDataPanelTitle")}
                        </ExpandablePanelHeader>
                        <ExpandablePanelBody className={styles.programPanelBody}>
                            <Row>
                                <Col md={4}>
                                    <Select
                                        label={t("request.groupProgramRequestTypeTitle")}
                                        name={"groupProgramRequest.type"}
                                        value={groupProgramRequest.type.id}
                                        onChange={handleGroupProgramRequestTypeChange}
                                        selectData={codeBookToSelectData(groupProgramRequestTypes)}
                                    />

                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Select
                                        label={t("common.educationSector")}
                                        name="programRequestSearch.educationSector"
                                        value={programRequestSearch?.educationSector?.id}
                                        onChange={handleProgramRequestEducationSectorChange}
                                        selectData={codeBookToSelectData(educationSectors)}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Autocomplete
                                        label={t("common.programName")}
                                        name="programRequestSearch.programId"
                                        value={programRequestSearch?.programId}
                                        onChange={handleProgramIdChange}
                                        getOptions={handleProgramNameSearch}
                                    />
                                    {/* <Select
                                        label={t("common.programName")}
                                        name="programRequestSearch.program"
                                        value={programRequestSearch?.program?.id}
                                        onChange={handleProgramRequestProgramChange}
                                        selectData={codeBookToSelectData(programs)}
                                    /> */}
                                </Col>
                                <Col md={4}>
                                    <Select
                                        label={t("request.programType")}
                                        name="programRequestSearch.programType"
                                        value={programRequestSearch?.programType?.id}
                                        onChange={handleProgramRequestProgramTypeChange}
                                        selectData={codeBookToSelectData(programTypes)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-5 mt-5">
                                <Col md={12} className="d-flex justify-content-end align-items-center">
                                    <Button onClick={search}>
                                        {t("common.search")}
                                    </Button>
                                    <Typography color="primary" className={styles.clearFilters + " ml-3"} onClick={clearFilters}>
                                        {t("common.clearFilters")}
                                    </Typography>
                                </Col>
                            </Row>
                            <Table {...tableProps} />
                            <Row className="mt-5">
                                <Col md={6} className="d-flex justify-content-end align-items-center">
                                    <Button
                                        className={styles.exportButton1}
                                        outline
                                        color={"primary"}
                                        icon={<DownloadIcon />}
                                        onClick={() => download(ExportTypeEnum.Csv)}
                                    >
                                        {t("common.downloadDocumentExtension", { extension: ".csv" })}
                                    </Button>
                                    <Button
                                        className={styles.exportButton}
                                        outline
                                        color={"primary"}
                                        icon={<DownloadIcon />}
                                        onClick={() => download(ExportTypeEnum.Excel)}
                                    >
                                        {t("common.downloadDocumentExtension", { extension: ".xslx" })}
                                    </Button>
                                </Col>
                                <Col md={6}>
                                    {/* <Button className="float-right" onClick={() => handleToggleCancelOtherLegalEntityModal()}> */}
                                    <Button className="float-right" onClick={() => handleToggleCancelConfirmModal()}>
                                        {t("request.create")}
                                    </Button>
                                </Col>
                            </Row>
                        </ExpandablePanelBody>
                    </ExpandablePanel>
                </Col>
            </Row>

            <Modal
                type={"confirm"}
                title={t("groupProgramRequest.otherLegalEntity.locationTitle")}
                cancelText={t("common.cancel")}
                confirmText={t("groupProgramRequest.otherLegalEntity.submitConsentForExecution")}
                variant="big"
                open={isOtherLegalEntityModalOpened}
                onClose={handleToggleCancelOtherLegalEntityModal}
                onConfirm={handleToggleConfirmOtherLegalEntityModal}
            >
                <div>
                    <Row>
                        <Col md={12}>
                            <Typography>{t("groupProgramRequest.otherLegalEntity.locationDescription")}</Typography>
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Typography>{t("groupProgramRequest.otherLegalEntity.requestForProgramExecution")}</Typography>
                            <Button color={"primary"} outline>{t("common.addDocument")}</Button>
                        </Col>
                        <Col md={6}>
                            <Typography>{t("groupProgramRequest.otherLegalEntity.contract")}</Typography>
                            <Button color={"primary"} outline>{t("common.addDocument")}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <br />
                            <TextField
                                label={t("request.legalEntityName")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <TextField
                                label={t("groupProgramRequest.otherLegalEntity.address")}
                            />
                        </Col>
                        <Col md={6}>
                            {/* <Autocomplete */}
                            <TextField
                                label={t("groupProgramRequest.otherLegalEntity.town")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <TextField
                                label={t("groupProgramRequest.otherLegalEntity.municipality")}
                            />
                        </Col>
                        <Col md={6}>
                            <TextField
                                label={t("groupProgramRequest.otherLegalEntity.county")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <DatePicker
                                label={t("common.dateFrom")}
                                minYear={new Date().getFullYear() - 25}
                                maxYear={new Date().getFullYear() + 25}
                            />
                        </Col>
                        <Col md={6}>
                            <DatePicker
                                label={t("common.dateTo")}
                                minYear={new Date().getFullYear() - 25}
                                maxYear={new Date().getFullYear() + 25}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                type={"confirm"}
                title={""}
                variant="big"
                cancelText={t("common.cancel")}
                confirmText={t("request.confirmRequestSubmission")}
                open={isConfirmModalOpened}
                onClose={handleToggleCancelConfirmModal}
                onConfirm={handleToggleConfirmConfirmModal}
            >
                <div>
                    <Row>
                        <Col md={12}>
                            <Typography className={styles.modalFirstLine}>{t("groupProgramRequest.confirmQuestion")}</Typography>
                            {/*<Typography className={styles.modalLine}>__________________________________________________</Typography>*/}
                        </Col>
                    </Row>
                    {tableData.filter(x => x.isSelected).length > 0 && tableData.filter(x => x.isSelected).map((data) =>
                        <Row>
                            <Col md={12}>
                                {(data.programCode && data.programCode !== undefined)
                                    ? <Typography className={styles.modalList}>{data.programName} ({data.programCode})</Typography>
                                    : <Typography className={styles.modalList}>{data.programName}</Typography>
                                }

                                {/* <Typography className={styles.modalList}>{data.programName}</Typography> */}
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col md={12}>
                            <br />
                            <Typography>{t("groupProgramRequest.confirmData")}</Typography>
                        </Col>
                    </Row>
                </div>

            </Modal>

            <Modal
                type={"message"}
                confirmText={t("common.ok")}
                open={isInformationModalOpened}
                onClose={handleToggleCancelInformationModal}
                onConfirm={handleToggleCancelInformationModal}
            >
                <div>
                    <Typography>{t("groupProgramRequest.successfullyCreated", { groupProgramRequestID: createdGroupProgramRequestID })}</Typography>
                </div>
            </Modal>
            <Modal
                type={"message"}
                confirmText={t("common.ok")}
                open={isSelectedProgramValidationModalOpened}
                onClose={handleToggleCloseValidationModal}
                onConfirm={handleToggleCloseValidationModal}
            >
                <div>
                    <Row>
                        <Col md={12}>
                            <Typography className={styles.modalFirstLine}>{t("groupProgramRequest.invalidProgramNumberHeader")}</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            {groupProgramRequest?.type?.id === ProgramRequestType.InstitutionBasicDataChange ?
                                (
                                    <Typography>{t("groupProgramRequest.invalidProgramNumberExtended")}</Typography>
                                ) :
                                (
                                    <Typography>{t("groupProgramRequest.invalidProgramNumber")}</Typography>
                                )
                            }
                        </Col>
                    </Row>
                </div>

            </Modal>

            <OtherLegalEntityLocationModal
                cancelText={t("common.cancel")}
                confirmText={t("groupProgramRequest.otherLegalEntity.submitConsentForExecution")}
                onConfirm={handleConfirmedOtherLegalEntityLocationModal}
                open={otherLegalEntityLocationModalOpened}
                value={otherLegalEntityLocation!}
                disableBody={true}
                onClose={handleCancelOtherLegalEntityLocationModal}
            />
        </>
    )
}